const labels = {
  All: { 'See the offering': '查看服务' },
  FacilityDetails: { 'Ref: Page title': '设施详情', 'Ref: Review': '查看' },
  FacilitiesList: { 'Ref: Page title': '设施', 'Ref: See details': '查看详情' },
};
export default labels;
